import { render, staticRenderFns } from "./WsMainBottomNav.vue?vue&type=template&id=81d7c650&"
import script from "./WsMainBottomNav.vue?vue&type=script&lang=js&"
export * from "./WsMainBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./WsMainBottomNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports